'use client';

import styled from 'styled-components';
import { colors } from '@/styles';

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* margin: 10px; */
  padding: 20px;
  background-color: ${colors.secondary.lightGray1};

  border: 1px solid ${colors.semantic.negative.primary};
`;

export const Title = styled.h6`
  color: ${colors.semantic.negative.primary};
`;

export const Code = styled.div`
  background-color: ${colors.primary.white};
  border: 1px solid ${colors.secondary.lightGray3};
  border-radius: 5px;

  & > pre {
    margin: 0;
    border-radius: 5px;
    /* background-color: ${colors.primary.white} !important; */
    border: none !important;
    padding: 10px !important;
  }
`;
